/* Jahrgang eines Spielers — reine Funktionen, kein DOM.
 *
 * Quelle der Wahrheit ist das Geburtsdatum (`dob`). `jg` gilt nur als Ersatz, wenn kein gültiges
 * Geburtsdatum da ist (Altbestand, Gäste ohne Datum). Damit laufen Jahrgangsknopf, Listenkarte,
 * Panelkopf, Player Info und Alterssortierung nie auseinander, auch wenn jemand das Geburtsdatum ändert.
 * Dieselbe Regel steht in der View players_public (supabase/gaeste-jahrgang-aus-dob.sql).
 */

const YEAR = /^(19|20)\d{2}$/;
const ISO = /^(\d{4})-(\d{2})-(\d{2})$/;

function text(v) {
  return v == null ? '' : String(v).trim();
}

/** Das Geburtsdatum als "JJJJ-MM-TT", wenn es ein echter Kalendertag in 19xx/20xx ist; sonst ''. */
export function validDob(dob) {
  const s = text(dob);
  const m = ISO.exec(s);
  if (!m || !YEAR.test(m[1])) return '';
  const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
  const check = new Date(Date.UTC(y, mo - 1, d));
  const real = check.getUTCFullYear() === y && check.getUTCMonth() === mo - 1 && check.getUTCDate() === d;
  return real ? s : '';
}

/** Geburtsjahr als vierstelliger Text; '' wenn unbekannt. Vorrang: gültiges dob, dann jg. */
export function birthYearOf(player) {
  const dob = validDob(player && player.dob);
  if (dob) return dob.slice(0, 4);
  const jg = text(player && player.jg);
  return YEAR.test(jg) ? jg : '';
}

/**
 * Spieler mit nachgezogenem jg: Ist ein gültiges dob gesetzt, wird jg daraus abgeleitet, damit der
 * gespeicherte Wert nie vom Geburtsdatum abweicht. Ohne gültiges dob bleibt jg unangetastet.
 * Liefert dasselbe Objekt zurück, wenn nichts zu ändern ist.
 */
export function withBirthYear(player) {
  const dob = validDob(player && player.dob);
  if (!dob || text(player.jg) === dob.slice(0, 4)) return player;
  return { ...player, jg: dob.slice(0, 4) };
}
